import React from 'react';
import { Box, Avatar, Typography, IconButton } from '@mui/material';
import { alpha } from '@mui/material/styles';
import DeleteIcon from '@mui/icons-material/Delete';
import { formatDistanceToNow } from 'date-fns';
import { getIcon } from './NotificationIcons';
import { useTheme } from '@mui/material';
import { tokens } from '../../theme';
import { enUS } from 'date-fns/locale';

const NotificationItem = ({ notification, onRead, onDelete, onClick }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const unreadBg = theme.palette.mode === 'dark'
    ? alpha(theme.palette.primary.main, 0.16)
    : alpha(theme.palette.primary.main, 0.08);
  const hoverBg = theme.palette.action.hover;

  const {
    
    title,
    message,
    isRead = false,
    createdAt,
    type = '',
    category = '',
    data = {}
  } = notification || {};

  const username = data.username || '';
  const icon = getIcon(type, title, category);

  const handleDelete = (e) => {
    e.stopPropagation();
    onDelete(notification);
  };

  const handleClick = () => {
    onRead(notification);
    if (onClick) onClick(notification);
  };

  // Vérifie si la notification est liée à une note de frais
  const isExpenseReport = category === 'expenseReport';

  return (
    <Box
      onClick={handleClick}
      sx={{
        p: 1.5,
        display: 'flex',
        alignItems: 'flex-start',
        gap: 1.5,
        cursor: 'pointer',
        backgroundColor: isRead ? 'transparent' : unreadBg,
        border: 1,
        borderColor: 'divider',
        borderRadius: 1,
        transition: 'background-color 0.2s ease',
        '&:hover': {
          backgroundColor: hoverBg,
        },
      }}
    >
      <Avatar
        sx={{
          bgcolor: theme.palette.mode === 'dark' ? alpha(theme.palette.primary.main, 0.24) : colors.primary[400],
        }}
      >
        {icon}
      </Avatar>

      <Box flex={1}>
        <Box display="flex" justifyContent="space-between" alignItems="flex-start">
          <Box flex={1}>
            <Typography variant="body2" color="text.primary" sx={{ fontWeight: isRead ? 400 : 600 }}>
              {title}
            </Typography>

            {message && (
              <Typography 
                variant="body2" 
                color="text.secondary"
                sx={{ 
                  mt: 0.5,
                  fontSize: '0.875rem'
                }}
              >
                {message}
              </Typography>
            )}

            <Typography 
              variant="caption" 
              color="text.secondary" 
              sx={{ 
                display: 'block',
                mt: 0.5,
                fontStyle: 'italic'
              }}
            >
              {username}
            </Typography>

            <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
              {createdAt ? formatDistanceToNow(new Date(createdAt), { 
                addSuffix: true,
                locale: enUS
              }) : ''}
            </Typography>
          </Box>
          
          <IconButton 
            onClick={handleDelete}
            size="small"
            sx={{ 
              color: theme.palette.text.secondary,
              '&:hover': {
                color: theme.palette.error.main,
              }
            }}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
};

export default NotificationItem;
